require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./case-studies-woodfield-24.json") })
        }
      }, "path---case-studies-woodfield-24");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---case-studies-woodfield-24!./.cache/json/case-studies-woodfield-24.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---case-studies-woodfield-24!./.cache/json/case-studies-woodfield-24.json
// module chunks = 231608221292675